<template>
  <div>
    <!-- ICON -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              ICONS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <div class="row clearfix mh1 pt1">
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-remove-to-list" />
                  <span class="mls"> icon-remove-to-list</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-add-to-list" />
                  <span class="mls"> icon-add-to-list</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-logout" />
                  <span class="mls"> icon-logout</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-settings" />
                  <span class="mls"> icon-settings</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-send-message2" />
                  <span class="mls"> icon-send-message2</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-print" />
                  <span class="mls"> icon-print</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-referances" />
                  <span class="mls"> icon-referances</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-project" />
                  <span class="mls"> icon-project</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-microphone" />
                  <span class="mls"> icon-microphone</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-ability" />
                  <span class="mls"> icon-ability</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-exam" />
                  <span class="mls"> icon-exam</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-cursor" />
                  <span class="mls"> icon-cursor</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-language" />
                  <span class="mls"> icon-language</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-education" />
                  <span class="mls"> icon-education</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-file" />
                  <span class="mls"> icon-file</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-add3" />
                  <span class="mls"> icon-add3</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-attach" />
                  <span class="mls"> icon-attach</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-calculate" />
                  <span class="mls"> icon-calculate</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-filter2" />
                  <span class="mls"> icon-filter2</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-like2" />
                  <span class="mls"> icon-like2</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-lock" />
                  <span class="mls"> icon-lock</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-menu" />
                  <span class="mls"> icon-menu</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-oval-checkbox-selected" />
                  <span class="mls"> icon-oval-checkbox-selected</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-question-mark" />
                  <span class="mls"> icon-question-mark</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-tips" />
                  <span class="mls"> icon-tips</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-down-arrow" />
                  <span class="mls"> icon-down-arrow</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-filter" />
                  <span class="mls"> icon-filter</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-up-arrow" />
                  <span class="mls"> icon-up-arrow</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-checkbox-blank2" />
                  <span class="mls"> icon-checkbox-blank2</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-checkbox-selected2" />
                  <span class="mls"> icon-checkbox-selected2</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-radio-blank" />
                  <span class="mls"> icon-radio-blank</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-radio-selected" />
                  <span class="mls"> icon-radio-selected</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-add" />
                  <span class="mls"> icon-add</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-add2" />
                  <span class="mls"> icon-add2</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-applicant-list" />
                  <span class="mls"> icon-applicant-list</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-bell" />
                  <span class="mls"> icon-bell</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-blank" />
                  <span class="mls"> icon-blank</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-browse" />
                  <span class="mls"> icon-browse</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-business" />
                  <span class="mls"> icon-business</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-caret-down" />
                  <span class="mls"> icon-caret-down</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-caret-up" />
                  <span class="mls"> icon-caret-up</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-clear" />
                  <span class="mls"> icon-clear</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-clear-all" />
                  <span class="mls"> icon-clear-all</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-close" />
                  <span class="mls"> icon-close</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-contact" />
                  <span class="mls"> icon-contact</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-cv" />
                  <span class="mls"> icon-cv</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-delete" />
                  <span class="mls"> icon-delete</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-disabled" />
                  <span class="mls"> icon-disabled</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-dropdown" />
                  <span class="mls"> icon-dropdown</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-edit" />
                  <span class="mls"> icon-edit</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-executive" />
                  <span class="mls"> icon-executive</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-forward" />
                  <span class="mls"> icon-forward</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-info" />
                  <span class="mls"> icon-info</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-left-arrow" />
                  <span class="mls"> icon-left-arrow</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-light-bulb" />
                  <span class="mls"> icon-light-bulb</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-like" />
                  <span class="mls"> icon-like</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-list" />
                  <span class="mls"> icon-list</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-message" />
                  <span class="mls"> icon-message</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-minus" />
                  <span class="mls"> icon-minus</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-more" />
                  <span class="mls"> icon-more</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-new-tab" />
                  <span class="mls"> icon-new-tab</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-personal" />
                  <span class="mls"> icon-personal</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-present" />
                  <span class="mls"> icon-present</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-purchased" />
                  <span class="mls"> icon-purchased</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-right-arrow" />
                  <span class="mls"> icon-right-arrow</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-save" />
                  <span class="mls"> icon-save</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-search" />
                  <span class="mls"> icon-search</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-send-message" />
                  <span class="mls"> icon-send-message</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-share" />
                  <span class="mls"> icon-share</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-tick" />
                  <span class="mls"> icon-tick</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-university" />
                  <span class="mls"> icon-university</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-unlike" />
                  <span class="mls"> icon-unlike</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-warning" />
                  <span class="mls"> icon-warning</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-work-bag" />
                  <span class="mls"> icon-work-bag</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-blue-collar-mini" />
                  <span class="mls"> icon-blue-collar-mini</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-checkbox-blank" />
                  <span class="mls"> icon-checkbox-blank</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-checkbox-selected" />
                  <span class="mls"> icon-checkbox-selected</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-lightning" />
                  <span class="mls"> icon-lightning</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-radio-list" />
                  <span class="mls"> icon-radio-list</span>
                </div>
              </div>
              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-white-collar-mini" />
                  <span class="mls"> icon-white-collar-mini</span>
                </div>
              </div>

              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-certificate" />
                  <span class="mls"> icon-certificate</span>
                </div>
              </div>

              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-list2" />
                  <span class="mls"> icon-list2</span>
                </div>
              </div>

              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-applicantpool" />
                  <span class="mls"> icon-applicantpool</span>
                </div>
              </div>

              <div class="gglyph fs1 col-2 mb-3">
                <div class="clearfix bshadow0 pbs">
                  <span class="icon-hrvenue" />
                  <span class="mls"> icon-hrvenue</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Icons',
  data() {
    return {};
  },
  computed: {},
};
</script>
